/**
 * @generated SignedSource<<ef54f6372cef355774421dfd8373e12a>>
 * @relayHash 5f5da1b821db43d4e120cbb1b1fdc016
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02379d49e10633b453b929c8009fba5f31f720b1654a58b5f3acda7f2aae3dc9

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueViewDevPanelSummaryDataQuery$variables = {
  cloudId: string;
  issueKey: string;
};
export type issueViewDevPanelSummaryDataQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly devOpsIssuePanel: {
        readonly " $fragmentSpreads": FragmentRefs<"ConnectedDevPanelApp_DevPanelApp" | "DevPanelAnalytics_issue" | "EmptyStatePrompt_jiraDevOpsIssuePanel">;
      } | null;
    } | null;
  };
};
export type issueViewDevPanelSummaryDataQuery = {
  response: issueViewDevPanelSummaryDataQuery$data;
  variables: issueViewDevPanelSummaryDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  {
    "kind": "ScalarField",
    "name": "message"
  },
  {
    "concreteType": "JiraIssueDevSummaryErrorProviderInstance",
    "kind": "LinkedField",
    "name": "instance",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "baseUrl"
      }
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "count"
},
v6 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v7 = {
  "concreteType": "JiraIssueDevSummaryByProvider",
  "kind": "LinkedField",
  "name": "summaryByProvider",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v9 = {
  "kind": "ScalarField",
  "name": "stateCount"
},
v10 = {
  "kind": "ScalarField",
  "name": "state"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueViewDevPanelSummaryDataQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraDevOpsIssuePanel",
                  "kind": "LinkedField",
                  "name": "devOpsIssuePanel",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "EmptyStatePrompt_jiraDevOpsIssuePanel"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "ConnectedDevPanelApp_DevPanelApp"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "DevPanelAnalytics_issue"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueViewDevPanelSummaryDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraDevOpsIssuePanel",
                "kind": "LinkedField",
                "name": "devOpsIssuePanel",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "panelState"
                  },
                  {
                    "concreteType": "JiraIssueDevSummaryResult",
                    "kind": "LinkedField",
                    "name": "devSummaryResult",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueDevSummaryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v4/*: any*/)
                      },
                      {
                        "concreteType": "JiraIssueDevSummaryError",
                        "kind": "LinkedField",
                        "name": "configErrors",
                        "plural": true,
                        "selections": (v4/*: any*/)
                      },
                      {
                        "concreteType": "JiraIssueDevSummary",
                        "kind": "LinkedField",
                        "name": "devSummary",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "branch",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueBranchDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "commit",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueCommitDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "pullrequest",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssuePullRequestDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v8/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "review",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueReviewDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraIssueDevSummaryByProvider",
                                "kind": "LinkedField",
                                "name": "summaryByProvider",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v3/*: any*/),
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "build",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueBuildDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "failedBuildCount"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "successfulBuildCount"
                                  },
                                  (v8/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "unknownBuildCount"
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "deploymentEnvironments",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                    "kind": "LinkedField",
                                    "name": "topEnvironments",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "title"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasBranchCapabilities"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "devOpsIssuePanelBanner"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "02379d49e10633b453b929c8009fba5f31f720b1654a58b5f3acda7f2aae3dc9",
    "metadata": {},
    "name": "issueViewDevPanelSummaryDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1948a34eeb0775d523615543e949f97e";

export default node;
